import { Interval } from '@mews-commander/types';
import { DateTimeUtcService } from '@mews/framework';

export const chunkIntervalIntoMonths = (interval: Interval, months = 6) => {
    const { startUtc, endUtc } = interval;

    const beginningUtc = DateTimeUtcService.parse(startUtc);
    const endingUtc = DateTimeUtcService.parse(endUtc);
    const diffMonths = DateTimeUtcService.diffMonths(endingUtc, beginningUtc);

    if (diffMonths <= months) return [interval];

    const numChunks = Math.ceil(diffMonths / months);
    const chunks = [...Array(numChunks).keys()];

    return chunks.map((i) => {
        const end = Math.min(diffMonths, i * months + months);

        return {
            startUtc: DateTimeUtcService.addMonths(beginningUtc, i * months).value,
            endUtc: end === diffMonths ? endingUtc.value : DateTimeUtcService.addMonths(beginningUtc, end).value,
        };
    });
};
